const TeacherCommentsSignBox = ({ isRead = false }) => {
    return (
        <div className='pt-4 pb-3 px-5' style={{ border: "1px solid #888", borderTop: "0" }}>
            <div className='d-flex justify-content-between w-full'>
                <div>Date: </div>
                <div style={{ marginRight: "200px" }}>Principal:</div>
            </div>
            <div className='text-center'>
                <div className='py-3 fs-2'>KGS INTERNATIONAL SCHOOL</div>
                <address className='mb-0'>
                    Số1 Trịnh Văn Bô, Phương Canh, Quận Nam TừLiêm, Hà Nội<br />
                    TEL 024 3201 3131 / E-mail : hanoi@kgsedu.net / Web http://www.kgs.edu.vn
                </address>
            </div>
        </div>
    )
}

export default TeacherCommentsSignBox